import { render, staticRenderFns } from "./EmailLoginLink.vue?vue&type=template&id=76883a37&scoped=true&"
import script from "./EmailLoginLink.vue?vue&type=script&lang=js&"
export * from "./EmailLoginLink.vue?vue&type=script&lang=js&"
import style0 from "./EmailLoginLink.vue?vue&type=style&index=0&id=76883a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76883a37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VIcon,VRow})
